<div mat-dialog-content>
    @for (imageUrl of data.imageUrl; track $index) {
        <div class="image-container">
            <img
                [src]="imageUrl"
                alt="Full Size Image"
                class="full-size-image"
            />
        </div>
    }
</div>
